/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faint_Gold_Cat_CallInputs */

const en_faint_gold_cat_call = /** @type {(inputs: Faint_Gold_Cat_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import access rights`)
};

const de_faint_gold_cat_call = /** @type {(inputs: Faint_Gold_Cat_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugriffsrechte importieren`)
};

/**
* | output |
* | --- |
* | "Import access rights" |
*
* @param {Faint_Gold_Cat_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_gold_cat_call = /** @type {((inputs?: Faint_Gold_Cat_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Gold_Cat_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_gold_cat_call(inputs)
	return de_faint_gold_cat_call(inputs)
});